import { DataCapsule, CachedStorageStrategy, LocalStorageStrategy, WixStorageStrategy, NOT_FOUND } from 'data-capsule';
import { storePubSub } from './applications/consts.js';

class CartApi {
  constructor(namespace) {
    this.namespace = namespace;
    // if (utils.isDev()) {
    this.dataStorage = new DataCapsule({
      strategy: new LocalStorageStrategy(),
      namespace
    });
    // } else {
    //   this.dataStorage = new DataCapsule({
    //     strategy: new CachedStorageStrategy({
    //       remoteStrategy: new WixStorageStrategy(),
    //       localStrategy: new LocalStorageStrategy()
    //     }),
    //     namespace
    //   });
    // }
  }

  addToCart(uuid, itemId, galleryId, providerId, quantity, isDemo, metadata) {
    const newItem = {
      uuid,
      itemId,
      galleryId,
      providerId,
      quantity,
      isDemo,
      metadata,
    };
    return this.setItem(uuid, newItem).then(() => {
      this.notifyCartChange();
    });
  }

  removeFromCart(uuid) {
    return this.dataStorage.removeItem(uuid).then(() => {
      this.notifyCartChange();
    });
  }

  notifyCartChange() {
    if (window.Wix) {
      Wix.PubSub.publish(storePubSub.refreshCart, {}, true);
    }
  }

  clearCart() {
    return this.getCartItems('*').then(arrItems => {
      const arrPromises = [];
      arrItems.forEach(item => {
        const uuid = item.uuid;

        arrPromises.push(this.dataStorage.removeItem(uuid));
      });

      return Promise.all(arrPromises);
    }).then(() => {
      this.notifyCartChange();
    });
  }

  setItem(uuid, item, expiration = 86400 /* 24 hours */ ) {
    return this.dataStorage.setItem(uuid, item, {
      expiration
    });
  }

  updateCartItem(uuid, metadata, quantity) {
    return this.dataStorage.getItem(uuid).then(cartItem => {
      let returnPromise = null;
      if (cartItem) {
        cartItem.metadata = metadata || cartItem.metadata;
        cartItem.quantity = quantity || cartItem.quantity;
        returnPromise = this.setItem(uuid, cartItem)
          .then(() => {
            this.notifyCartChange();
          });
      } else {
        returnPromise = Promise.reject('Item not found');
      }
      return returnPromise;
    });
  }

  getCartItems(connectedProviderId, options = {}) {
    if (!connectedProviderId) {
      const message = `Can't get cart items without providerId`;
      console.error(message);
      throw message;
    }

    try {
      return this.dataStorage.getAllItems().then(objCartItems => {
        const cartItems = [];
        const itemUUID = options.uuid;
        for (var cartItemUuid in objCartItems) {
          const cartItemCandidate = objCartItems[cartItemUuid];
          const { uuid, providerId } = cartItemCandidate;
          const isUUIDValid = !itemUUID || itemUUID === uuid;
          const isSameProviderId = !connectedProviderId || (connectedProviderId === providerId) || (connectedProviderId === '*');
          const shouldAddItem = isUUIDValid && isSameProviderId;

          if (shouldAddItem) {
            var cartItem = objCartItems[uuid];
            cartItems.push(cartItem);
          }
        }

        return cartItems;
      });
    } catch (error) {
      console.error('CartApi - getCartItems - ERROR:', error);
    }
  }

  containsDemoItems(connectedProviderId) {
    return this.getCartItems(connectedProviderId)
      .then(items => items.filter(item => item.isDemo))
      .then(demoItems => demoItems.length > 0)
  }

  createCartForm() {
    this.hideCart();
    if (Wix.Utils.getViewMode() == 'site' || Wix.Utils.getViewMode() == 'preview') {
      Wix.openPopup(window.location.origin + '/cart-form.html?isStore=true', '0%', '100%', {
        origin: Wix.WindowOrigin.FIXED,
        placement: Wix.WindowPlacement.CENTER
      }, null, Wix.Theme.BARE);
    }
  }

  showCart() {
    Wix.PubSub.publish("showCart", {}, false)
  }

  hideCart() {
    Wix.PubSub.publish("closeCartForm", {}, false)
  }

  publishAddToCart(dataToSend) {
    Wix.PubSub.publish('ADD_TO_CART', dataToSend, true)
  }
}

let domain = '';
if (window.instanceId) {
  domain = window.instanceId;
} else {
  try {
    if (window.Wix) {
      domain = Wix.Utils.getInstanceId();
    } else {
      // We're in a test
      domain = 'test';
    }
  } catch (error) {
    console.log(`error domain`, error);
  }
}
module.exports = new CartApi(domain);



// WEBPACK FOOTER //
// ./store/cartApi.js